// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__1-3gK","button":"Form_button__2vcKa"};